<template>
    <div class="pay-goods-page" v-if="isShow">
        <div class="dialog-mask"></div>
        <div class="pay-goods-content mask-content">
            <span class="close-icon" @click="isShow = false"></span>
            <div class="pay-title">开通会员 免费畅玩{{ landpageGameName }}</div>
            <div class="goods-wrap">
                <div @click="chooseVipGoods(item, 'click', index)" class="goods-item" :class="{ active: item.id == activeId }" v-for="(item, index) in goodsList" :key="item.id">
                    <div class="goods-name">{{ item.name }}</div>
                    <div class="goods-price">
                        <i class="i1">¥</i>
                        <i class="i2">{{ item.showOriginPrice ? item.original_price : item.current_price }}</i>
                    </div>
                </div>
            </div>
            <div class="pay-section">
                <div class="pay-left">
                    <div class="qrcode-wrap">
                        <div class="qrcode-section">
                            <div class="goods-qrcode" ref="goods-qrcode"></div>
                        </div>
                        <div class="qrcode-loading" v-if="loading">
                            <span class="icon"></span>
                        </div>
                        <div class="qrcode-succ" v-if="payStatus == 'succ'">
                            <div class="dv1">支付成功</div>
                        </div>
                        <div class="qrcode-invalid" v-if="payStatus == 'fail'">
                            <div class="dv1">二维码已失效</div>
                            <div class="dv2" @click="payAgain">刷新</div>
                        </div>
                    </div>
                </div>
                <div class="pay-right">
                    <div class="pay-icon-wrap">
                        <div class="dv1">
                            <span>支持</span>
                            <span class="icon zfb-icon" v-if="zfb"></span>
                            <span class="icon wx-icon" v-if="wx"></span>
                            <span>扫码支付</span>
                        </div>
                    </div>
                    <div class="price-wrap">
                        <span class="sp0">同意并支付</span>
                        <span class="sp1">¥</span>
                        <span class="sp2">{{ currentChoosedVipGoods.showOriginPrice ? currentChoosedVipGoods.original_price : currentChoosedVipGoods.current_price }}</span>
                    </div>
                    <div class="agree">
                        <i class="i1">已阅读并同意</i>
                        <a class="a1" target="_blank" :href="payAgreement">付费服务协议</a>
                        <span>|</span>
                        <a class="a1" target="_blank" :href="customerLink">联系客服</a>
                        <span>|</span>
                        <a class="a1" target="_blank" @click="watchOrder">查看订单</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import config from '@/http/config'
import QRCode from 'qrcodejs2'
import { cancelRequest } from '@/http'
import { getCookieToken } from '@/utils/auth'
import { createVipOrder, queryOrderStatus } from '@/http/api/order'

export default {
    name: 'PayGoods',
    data() {
        return {
            activeId: '',
            goodsList: [],
            currentChoosedVipGoods: {},
            isShow: false,
            payStatus: '',
            showBlank: false,
            loading: true,
            wx: false,
            zfb: false,
            queryTimes: 0, // 查询订单次数
            errorTimes: 0 // 重试次数,
        }
    },
    computed: {
        ...mapState(['payAgreement', 'landpageGameName']),
        ...mapGetters(['customerLink'])
    },
    watch: {
        isShow: function (value) {
            if (value) {
                this.$nextTick(() => {
                    this.$Utils.setDialogZindex('pay-goods-page')
                })
            } else {
                this.payStatus = ''
                this.showBlank = false
                this.loading = true
                this.wx = false
                this.zfb = false
                this.queryTimes = 0
                this.errorTimes = 0
                clearTimeout(this.queryStatusTimeId)
                clearTimeout(this.queryRetryTimeId)
            }
        }
    },
    methods: {
        show(data) {
            const { item, list, wx, zfb } = data
            this.isShow = true
            this.wx = wx
            this.zfb = zfb
            this.activeId = item.id
            this.goodsList = list
            this.chooseVipGoods(item)
            this.$Utils.report({ event: '盒子家庭端百度推广按钮上报统计', event_id: 38, n3: 10 })
        },
        chooseVipGoods(item, type, index) {
            if (type == 'click') {
                if (index == 2) {
                    this.$Utils.report({ event: '盒子家庭端百度推广按钮上报统计', event_id: 38, n3: 5, n4: item.id })
                } else if (index == 1) {
                    this.$Utils.report({ event: '盒子家庭端百度推广按钮上报统计', event_id: 38, n3: 6, n4: item.id })
                } else if (index == 0) {
                    this.$Utils.report({ event: '盒子家庭端百度推广按钮上报统计', event_id: 38, n3: 7, n4: item.id })
                }
            }

            if (item) {
                this.currentChoosedVipGoods = { ...item }
            }

            this.activeId = this.currentChoosedVipGoods.id
            this.queryTimes = 0
            this.errorTimes = 0
            this.showBlank = false
            this.payStatus = ''
            this.$refs['goods-qrcode'] && (this.$refs['goods-qrcode'].innerHTML = '')
            clearTimeout(this.queryStatusTimeId)
            clearTimeout(this.queryRetryTimeId)
            this.cancelRequest()
            this.createOrder()
        },
        // 创建订单
        createOrder() {
            if (!getCookieToken()) {
                return this.$Login.show({
                    scene: 'cb',
                    callback: () => {
                        this.createOrder()
                    }
                })
            }

            const data = {
                g_id: this.currentChoosedVipGoods.id,
                channel: this.$Utils.getNowChannel(),
                pay_by: '',
                client_ip: this.$store.state.client_ip,
                type: 0,
                location_gid: 0
            }
            const { showOriginPrice, original_price } = this.currentChoosedVipGoods
            const current_price = showOriginPrice ? original_price : this.currentChoosedVipGoods.current_price
            this.loading = true
            createVipOrder(data)
                .then((res) => {
                    this.loading = false
                    if (res && this.$Utils.isObject(res.data)) {
                        let url = config.WEB_DOMAIN + `/commonPay.html?orderId=${res.data.id}&orderPrefix=BOX&orderMoney=${current_price}`
                        this.$refs['goods-qrcode'].innerHTML = ''
                        const { id } = res.data
                        this.orderId = id
                        this.creatQrCode(url)
                        this.queryStatus(id)
                        this.current_price = current_price
                    }
                })
                .catch((err) => {
                    // 长时间停留在会员页面，此时token已经过期了
                    if (err.response && err.response.status === 401) {
                        this.$Login.show()
                    }
                    this.loading = false
                })
        },
        // 创建二维码
        creatQrCode(url) {
            console.log('支付地址=======>', url)
            this.qrcode = new QRCode(this.$refs['goods-qrcode'], {
                text: url,
                width: 130,
                height: 130,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H
            })
            this.showBlank = true

            this.$nextTick(() => {
                this.$refs['goods-qrcode'].title = ''
            })
        },
        // 查询订单状态
        queryStatus(orderId) {
            clearTimeout(this.queryStatusTimeId)
            const path = this.$route.path
            if (['/vip', '/profile'].indexOf(path) == -1) {
                return clearTimeout(this.queryStatusTimeId)
            }
            if (!orderId) {
                clearTimeout(this.queryStatusTimeId)
                return false
            }

            let timeCell = 1000
            this.queryTimes++

            // 根据查询的次数
            if (this.queryTimes < 60) {
                timeCell = 1000
            } else if (this.queryTimes < 120) {
                timeCell = 1500
            } else if (this.queryTimes < 180) {
                timeCell = 2000
            } else if (this.queryTimes < 240) {
                timeCell = 2500
            } else {
                timeCell = 3000
            }
            queryOrderStatus({ orderId, orderPrefix: 'BOX' })
                .then((res) => {
                    if (res.code == 200 && this.$Utils.isObject(res.data)) {
                        const { status } = res.data
                        if (!status) {
                            // 未支付
                            this.queryStatusTimeId = setTimeout(() => {
                                this.queryStatus(orderId)
                            }, timeCell)
                        } else if (status == 1) {
                            // 支付成功
                            this.isShowPayStatus = true
                            this.payStatus = 'succ'
                            this.queryTimes = 0
                            this.errorTimes = 0
                            clearInterval(this.queryStatusTimeId)
                            clearInterval(this.queryRetryTimeId)
                            this.$PayFinished.show()
                            this.isShow = false

                            const bd_vid = this.$cookies.get('bd_vid')
                            if (bd_vid) {
                                this.$Utils.report({ event: 'ocpc上报', event_id: 40, n2: 0, v1: 'pay', v2: bd_vid, v3: 'box_web', f1: this.current_price })
                            }
                        } else {
                            this.payStatus = 'fail'
                        }
                    } else {
                        // 查询接口非200状态码
                        this.queryStatusTimeId = setTimeout(() => {
                            this.queryStatus(orderId)
                        }, timeCell)
                    }
                })
                .catch(() => {
                    // 网络错误、服务器挂了等其他情况，3s后重试，重试次数最大60次
                    clearTimeout(this.queryRetryTimeId)
                    this.errorTimes++
                    if (this.errorTimes < 60) {
                        this.queryRetryTimeId = setTimeout(() => {
                            this.queryStatus(orderId)
                        }, 3000)
                    } else {
                        clearTimeout(this.queryStatusTimeId)
                        this.$Toast.show('网络错误')
                    }
                })
        },
        // 订单过期后重新支付
        payAgain() {
            this.queryTimes = 0
            this.errorTimes = 0
            this.payStatus = ''
            this.isShowPayStatus = false
            this.chooseVipGoods()
        },
        // 取消创建订单和查询订单请求
        cancelRequest() {
            cancelRequest('/box/member/createOrder')
            cancelRequest('/order/getOrderStatus')
        },
        watchOrder() {
            $('.common-bottom').hide()
            this.isShow = false
            this.$router.push('/profile?id=2')
        }
    }
}
</script>

<style lang="less" scoped>
.pay-goods-page {
    .pay-goods-content {
        position: fixed;
        width: 560px;
        height: 530px;
        background: linear-gradient(180deg, #fdf7ea, #ffffff);
        border-radius: 10px;

        .close-icon {
            width: 15px;
            height: 16px;
            background: url(../../../assets/dialog/close.png) center/100% no-repeat;

            &:hover {
                background: url(../../../assets/dialog/close-hover.png) center/100% no-repeat;
            }
        }

        .pay-title {
            margin-top: 35px;
            color: #8e5126;
            font-weight: bold;
            text-align: center;
        }

        .goods-wrap {
            margin-top: 40px;
            display: flex;
            padding: 0 40px;
            justify-content: space-between;

            .goods-item {
                padding-top: 55px;
                width: 140px;
                height: 180px;
                text-align: center;
                cursor: pointer;
                background: url(../../../assets/default-bd.png) center/100% no-repeat;

                &.active {
                    background-image: url(../../../assets/active-bd.png);
                }

                .goods-name {
                    color: #333333;
                    font-size: 20px;
                    text-align: center;
                    line-height: 20px;
                }

                .goods-price {
                    color: #ff6936;
                    margin-top: 16px;

                    font-weight: bold;

                    .i1 {
                        font-size: 20px;
                    }

                    .i2 {
                        line-height: 36px;
                        font-size: 36px;
                    }
                }
            }
        }

        .pay-section {
            margin-top: 39px;
            display: flex;
            padding: 0 0 0 40px;

            .pay-left {
                margin-right: 10px;

                .qrcode-wrap {
                    width: 160px;
                    height: 160px;
                    position: relative;
                    border-radius: 10px;

                    .qrcode-section {
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        z-index: 2;
                        background-color: @color-txt-high;
                        border-radius: 10px;
                        border: 1px solid #ebebeb;

                        .goods-qrcode {
                            position: absolute;
                            width: 130px;
                            height: 130px;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);

                            ::v-deep img {
                                width: 100%;
                                height: 100%;
                            }
                        }
                    }

                    .qrcode-loading {
                        position: absolute;
                        z-index: 3;
                        width: 100%;
                        height: 100%;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        background: #fff;
                        border-radius: 10px;

                        .icon {
                            width: 32px;
                            height: 32px;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            background: url(../../../assets/dialog/loading.gif) center/100% no-repeat;
                        }
                    }

                    .qrcode-succ,
                    .qrcode-invalid {
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        background: linear-gradient(#000000b3, #000000b3);
                        z-index: 3;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        border-radius: 9px;

                        .dv1 {
                            text-align: center;
                            line-height: 23px;
                            color: @color-txt-high;
                            font-size: 18px;
                        }

                        .dv2 {
                            margin: 17px auto 0;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            width: 96px;
                            height: 32px;
                            border-radius: 43px;
                            background: linear-gradient(90.64deg, #ffe0c1 0.41%, #f2ab74 100.09%);
                            color: #6b3d1e;
                            font-weight: 600;
                            font-size: 16px;
                            cursor: pointer;
                        }
                    }
                }
            }

            .pay-right {
                flex: 1;

                .price-wrap {
                    margin-top: 52px;
                    font-weight: bold;
                    color: #ff6936;
                    font-size: 14px;

                    .sp0 {
                        color: #333333;
                    }

                    .sp1 {
                        margin-left: 7px;
                        font-size: 20px;
                    }

                    .sp2 {
                        font-size: 36px;
                    }
                }

                .goods-decs-wrap {
                    margin-top: 20px;
                    text-align: left;

                    .info-wrap {
                        .info-item {
                            &:nth-child(1) {
                                margin-bottom: 10px;
                            }

                            span {
                                font-size: 14px;
                            }

                            .field {
                                color: @color-txt-normal;
                                margin-right: 10px;
                            }

                            .field-value {
                                color: @color-txt-high;
                            }
                        }
                    }
                }

                .pay-icon-wrap {
                    .dv1 {
                        display: flex;
                        align-items: center;
                        padding: 0 10px;
                        font-size: 0;
                        width: 310px;
                        height: 35px;
                        background: #f7f7f7;
                        border-radius: 10px;

                        span {
                            font-size: 14px;
                            color: @color-txt-normal;
                            display: inline-block;
                            margin: 0 4px 0 0;
                            vertical-align: middle;

                            &:last-child {
                                margin-right: 0;
                            }
                        }

                        .icon {
                            width: 18px;
                            height: 18px;

                            &.wx-icon {
                                background: url(../../../assets/wx-icon.png) center no-repeat;
                                background-size: 100% 100%;
                            }

                            &.zfb-icon {
                                background: url(../../../assets/zfb-icon.png) center no-repeat;
                                background-size: 100% 100%;
                            }
                        }
                    }
                }

                .agree {
                    text-align: left;
                    font-size: 14px;
                    line-height: 18px;

                    i {
                        font-style: normal;
                        color: #999;
                    }

                    span {
                        margin: 0 6px;
                    }

                    a {
                        text-decoration: none;
                        color: #333;
                        cursor: pointer;

                        &:hover {
                            color: #4cb3f5;
                        }
                    }
                }
            }
        }
    }
}
</style>
